import store from "@/store";
import { computed, onMounted } from "@vue/composition-api";

export default function useStepForm() {

  onMounted(() => {
    store.dispatch("external_personnel_access_control_activities/getAll");
  });

  const activityOptions = computed(() => {
    return store.getters["external_personnel_access_control_activities/getSelectedItems"];
  });

  return {
    activityOptions,
  };
}

